/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-sort': {
    width: 12,
    height: 13,
    viewBox: '0 0 12 13',
    data: '<g clip-path="url(#svgicon-icon-sort-a)" _stroke="#515151" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M3.528 3.505l-.065 6.03M6.291 7.846l-2.828 2.828L.634 7.846M11.357 4.495h-4.5M11.357 7.495h-3M11.357 1.495h-7.5M11.357 10.495h-1.5"/></g><defs><clipPath id="svgicon-icon-sort-a"><path pid="1" _fill="#fff" transform="translate(0 .07)" d="M0 0h12v12H0z"/></clipPath></defs>'
  }
})
